import { useSetAtom } from 'jotai/index';
import { useCallback } from 'react';
import { unsavedChangedHandlersAtom } from '../atoms/session-atoms';
export const useResetUnsavedChangesHandlers = () => {
  const setUnsavedChangesHandlers = useSetAtom(unsavedChangedHandlersAtom);
  const resetUnsavedChangesHandlers = useCallback(() => {
    setUnsavedChangesHandlers({
      apply: async () => {},
      exists: false
    });
  }, [setUnsavedChangesHandlers]);
  return {
    resetUnsavedChangesHandlers
  };
};
//# sourceMappingURL=use-reset-unsaved-changes-handlers.js.map